import app, { Component } from 'apprun';
import { isValidElement } from '../utils';

export default class CommonPropertyComponent extends Component {

  view = (state) => {
    if (!state.item) {return;}
    return (
      <form class="form-horizontal" style={{ width: '450px' }}>
        <div class="row">
          <div class="col-sm-12">{state.item.dispName}</div>
          {state.item.fieldTypeDetail !== 'multiline' ? (
            <div class="col-sm-12">
              <input
                id="inpText"
                size="62"
                class="form-control"
                value={state.newVal}
                oninput={(e) => {
                  state.newVal = e.target.value;
                }}
              />
            </div>
          ) : (
            <div class="col-sm-12">
              <textarea
                id="inpText"
                class="form-control"
                rows="10"
                value={state.item.value}
                oninput={(e) => {
                  state.newVal = e.target.value;
                }}></textarea>
            </div>
          )}
        </div>
        <div id="inpTextErrMsg" class="text-danger"></div>
        <div class="edit-buttons">
          <a
            type="button"
            class="btn btn-primary btn-xs"
            style={
              state.item.required || state.item.value === ''
                ? { display: 'none' }
                : { display: 'inline-block' }
            }
            onclick={() => state.caller.run(state.delete, state.item, state.panelId)}>
            delete
          </a>
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('save')}>
            save
          </a>
          <a
            type="button"
            class="btn btn-default btn-xs"
            onclick={() => state.caller.run(state.cancel, state.panelId)}>
            cancel
          </a>
        </div>
      </form>
    );
  };

  update = {
    save: (state) => {
      if (!state.newVal) {return;}

      if (state.item.fieldName === 'DCS ID') {state.item.validation = 'Max7dInteger';}

      if (isValidElement('inpText', state.item.validation)) {
        state.caller.run(state.save, state.item, state.panelId, state.newVal);
      }
    }
  };

  mounted = ({ state }) => {
    return { ...state,  newVal: state.item.value };

  };
}
